import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel with your project token
// We use import.meta.env for Vite environment variables
mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  debug: import.meta.env.DEV,
  track_pageview: true,
  persistence: 'localStorage'
});

// Define event names as constants to avoid typos
export const EVENTS = {
  INITIATE_PURCHASE: 'Initiate Purchase',
  CHANGE_TAB: 'Change Tab',
  VIEW_SIGN_IN_PAGE: 'View Sign In Page',
  VIEW_CHECKOUT_PAGE: 'View Checkout Page',
  INITIATE_SIGN_IN: 'Initiate Sign In',
  SIGN_IN: 'Sign In',
  SIGN_IN_ERROR: 'Sign In Error',
  VIEW_CONFIRM_ACCOUNT_PAGE: 'View Confirm Account Page',
  CHANGE_ACCOUNT: 'Change Account',
  INITIATE_CHECKOUT: 'Initiate Checkout',
  VIEW_SUCCESS_PAGE: 'View Success Page',
  CLICK_APP_STORE: 'Click App Store',
  CLICK_ACTIVATE_SUBSCRIPTION: 'Click Activate Subscription',
  VIEW_PRODUCT_PAGE: 'View Product Page',
} as const;

// Simple tracking function that accepts any event name
export function track(event: string, properties?: Record<string, any>) {
  mixpanel.track(event, properties);
}

// Export the mixpanel instance for direct access if needed
export default mixpanel;
